import { render, staticRenderFns } from "./MaterialsSelectorDialog.vue?vue&type=template&id=56496076&scoped=true"
import script from "./MaterialsSelectorDialog.vue?vue&type=script&lang=js"
export * from "./MaterialsSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsSelectorDialog.vue?vue&type=style&index=0&id=56496076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56496076",
  null
  
)

export default component.exports